import type { PropsWithChildren } from "react"
import Link from "next/link"
import {
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  TwitterIcon,
  BlueSkyIcon,
  YouTubeIcon,
  MastodonIcon,
  TikTokIcon,
  ThreadsIcon,
  WhatsAppIcon,
} from "common/components/icons/social"

interface SocialMediaLinkProps {
  icon: string
  href: string
  title?: string
}

interface SocialMediaIconProps {
  icon: string
}

const SocialMediaIcon = ({ icon }: PropsWithChildren<SocialMediaIconProps>) => {
  switch (icon) {
    case "facebook":
      return (
        <div className="group hover:bg-facebook flex size-14 rounded-full bg-white lg:size-11">
          <FacebookIcon className="fill-facebook m-auto size-5 group-hover:fill-white lg:size-4" />
        </div>
      )
    case "twitter":
      return (
        <div className="group hover:bg-twitter flex size-14 rounded-full bg-white lg:size-11">
          <TwitterIcon className="fill-twitter m-auto size-5 group-hover:fill-white lg:size-4" />
        </div>
      )
    case "bluesky":
      return (
        <div className="group hover:bg-bluesky flex size-14 rounded-full bg-white lg:size-11">
          <BlueSkyIcon className="fill-bluesky m-auto size-5 group-hover:fill-white lg:size-4" />
        </div>
      )
    case "instagram":
      return (
        <div className="group hover:bg-instagram flex size-14 rounded-full bg-white lg:size-11">
          <InstagramIcon className="fill-instagram m-auto size-5 group-hover:fill-white lg:size-4" />
        </div>
      )
    case "linkedin":
      return (
        <div className="group hover:bg-linkedin flex size-14 rounded-full bg-white lg:size-11">
          <LinkedInIcon className="fill-linkedin m-auto size-5 group-hover:fill-white lg:size-4" />
        </div>
      )
    case "youtube":
      return (
        <div className="group hover:bg-youtube flex size-14 rounded-full bg-white lg:size-11">
          <YouTubeIcon className="fill-youtube m-auto size-5 group-hover:fill-white lg:size-4" />
        </div>
      )
    case "mastodon":
      return (
        <div className="group hover:bg-mastodon flex size-14 rounded-full bg-white lg:size-11">
          <MastodonIcon className="fill-mastodon m-auto size-5 group-hover:fill-white lg:size-4" />
        </div>
      )
    case "tiktok":
      return (
        <div className="group flex size-14 rounded-full bg-white hover:bg-black lg:size-11">
          <TikTokIcon className="m-auto size-5 fill-black group-hover:fill-white lg:size-4" />
        </div>
      )
    case "whatsapp":
      return (
        <div className="group hover:bg-whatsapp flex size-14 rounded-full bg-white lg:size-11">
          <WhatsAppIcon className="fill-whatsapp m-auto size-5 group-hover:fill-white lg:size-4" />
        </div>
      )
    case "threads":
      return (
        <div className="group flex size-14 rounded-full bg-white hover:bg-black lg:size-11">
          <ThreadsIcon className="m-auto size-5 fill-black group-hover:fill-white lg:size-4" />
        </div>
      )
    default:
      return null
  }
}

export const SocialMediaLink = ({ icon, title, href }: PropsWithChildren<SocialMediaLinkProps>) => {
  return (
    <Link href={href} title={title} rel="me">
      <SocialMediaIcon icon={icon} />
    </Link>
  )
}
